let enddate = document.querySelector(".countdown-timer").getAttribute("data-end");
if(enddate != '')
{
  const endDateTime = new Date(enddate).getTime();
  
  // Function to update the countdown timer
  function updateCountdown() {
      const now = new Date().getTime(); // Current timestamp
      const timeRemaining = endDateTime - now;
  
      if (timeRemaining > 0) {
          // const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
          const hours = Math.floor(timeRemaining / (1000 * 60 * 60));
          // const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
  
          // Update HTML
          document.querySelector('.countdown-timer .hours').textContent = hours;
          document.querySelector('.countdown-timer .minutes').textContent = minutes;
          document.querySelector('.countdown-timer .seconds').textContent = seconds;
      } else {
          // Hide the countdown
          document.querySelector(".countdown-timer").style.display = 'none';
  
          // Stop the timer
          clearInterval(timerInterval);
      }
  }
  
  // Run the countdown timer every second
  const timerInterval = setInterval(updateCountdown, 1000);
}

